export default __webpack_public_path__ + "static/media/firefox.c8dbb20f.svg";